// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bbf61ca7","453":"c32549c3","455":"6705eeb2","977":"2dfabe6f"}[chunkId] + ".chunk.js";
};